import './cadastro.scss';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import cadastro from './Cadastro.vue';
import { plugin, defaultConfig } from '@formkit/vue';
import config from '../formkit.config'
import router from  './routes'

import sentryInitVue from '@/sentry/init-vue';

const app = createApp(cadastro).use(router);
  
sentryInitVue({ app });

app.use(createPinia());
app.use(plugin, defaultConfig(config))
app.mount('#app'); 